import React from "react";
import { NavLink, DataTable } from "../../components";
import { makeStyles } from "@material-ui/styles";
import Header from "./Header";
import sharedStyles, { dataTableStyles } from "../styles";
import { Helmet } from "react-helmet";
import { useEventHandlers } from "../../data/misc";
import { Tooltip } from "@material-ui/core";

const useStyles = makeStyles(sharedStyles);

const columns = [
  {
    name: "name",
    label: (
      <Tooltip title="Name">
        <div>Name</div>
      </Tooltip>
    ),
    renderer: (name) => (
      <Tooltip title={name}>
        <NavLink path={`/eventHandlerDef/${name}`}>{name}</NavLink>
      </Tooltip>
    ),
  },
  {
    name: "event",
    label: (
      <Tooltip title="Event">
        <div>Event</div>
      </Tooltip>
    ),
  },
  {
    name: "createTime",
    type: "date",
    label: (
      <Tooltip title="Create Time">
        <div>Create Time</div>
      </Tooltip>
    ),
  },
  {
    name: "actions",
    label: (
      <Tooltip title="Actions">
        <div>Actions</div>
      </Tooltip>
    ),
    renderer: (val) => JSON.stringify(val.map((action) => action.action)),
  },
];

export default function EventHandlers(props) {
  const permissions = props?.permissions;
  const classes = useStyles();

  const { data: eventHandlers, isFetching } = useEventHandlers();

  return (
    <div className={classes.wrapper}>
      <Header tabIndex={2} loading={isFetching} permissions={permissions} />
      <Helmet>
        <title>Conductor UI - Event Handler Definitions</title>
      </Helmet>

      <div className={classes.tabContent}>
        {eventHandlers && (
          <DataTable
            title={`${eventHandlers.length} results`}
            localStorageKey="eventHandlersTable"
            defaultShowColumns={["name", "event", "actions"]}
            keyField="name"
            data={eventHandlers}
            columns={columns}
            customStyles={dataTableStyles}
            fixedHeader
            fixedHeaderScrollHeight="calc( 100vh - 240px )"
          />
        )}
      </div>
    </div>
  );
}
